import moment from "moment";

export const TIPO_PEDIDO = [{ tipo: "Exacto" }, { tipo: "Aproximado" }];

export const empaqueInitialValues = {
  id_campo: 0,
  id_diaria: 0,
  variedad: "",
  variedad_bicolor: [],
  resto: false,
  calibre: "",
  total: 0,
  id_tipo_etiqueta: 0,
  id_peso_envase: 0,
  id_tipo_caja: 0,
  id_etiqueta: 0,
  id_bultos_por_palet: 0,
  bultos_por_palet: 0,
  cantidad_palet: 0,
  id_yeguere: 8, // 8 pruebas y prod
  id_destino: 1, // 1 pruebas y prod
  tipo_pedido: "Exacto",
  id_destino_inmediato: 4, // 4 pruebas y prod
  id_tarima: 1,
  fumigar: false,
  prioridad: false,
  observaciones: "",
  fecha: moment().format("YYYY-MM-DD"),
  limite: 0,
  bicolor: false,
  id_variedad: 0,
};

export const programacionkey = "@notificacion_programacion_empaque";
